import { APIURL } from "../models/api-base";
import {
  apiUrl_medialive_describe,
  apiUrl_medialive_metrics,
  apiUrl_medialive_start,
  apiUrl_medialive_stop,
  apiUrl_medialive_last_mp4,
  apiUrl_medialive_last_mp4_status,
} from "../models/api-urls";
import fetchService from "../modules/APIService";

class Service extends fetchService {
  constructor() {
    super(APIURL);
  }

  describe = async () => {
    try {
      const response = await this.get(apiUrl_medialive_describe);
      return response;
    } catch (error) {
      throw error;
    }
  };

  metrics = async () => {
    try {
      const response = await this.get(apiUrl_medialive_metrics);
      return response;
    } catch (error) {
      throw error;
    }
  };

  start = async () => {
    try {
      const response = await this.post(apiUrl_medialive_start, {});
      return response;
    } catch (error) {
      throw error;
    }
  };

  stop = async () => {
    try {
      const response = await this.post(apiUrl_medialive_stop, {});
      return response;
    } catch (error) {
      throw error;
    }
  };

  generateLastLiveMp4 = async () => {
    try {
      const response = await this.post(apiUrl_medialive_last_mp4, {});
      return response;
    } catch (error) {
      throw error;
    }
  };

  lastLiveMp4Status = async (jobId) => {
    try {
      const response = await this.get(
        `${apiUrl_medialive_last_mp4_status}?jobId=${encodeURIComponent(jobId)}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}

const MediaLiveService = new Service();

export default MediaLiveService;
